import axios from 'axios';

class GenericApiAdapter {
    headers;
    apiBaseUrl;
    initialQueryParams = {};
    constructor(apiBaseUrl, initialQueryParams = {}, headers = {}) {
        this.apiBaseUrl = apiBaseUrl;
        this.headers = headers;
        this.initialQueryParams = initialQueryParams;
    }
    getHeaders(headers = {}) {
        return {
            Accept: 'application/json',
            ...this.headers,
            ...headers,
        };
    }
    async get(url, headers = {}, queryParams) {
        const result = await axios.get(this.apiBaseUrl + encodeURI(url), {
            headers: this.getHeaders(headers),
            params: queryParams,
        });
        return result.data;
    }
    async post(url, body, headers = {}) {
        const result = await axios.post(this.apiBaseUrl + encodeURI(url), body, {
            headers: this.getHeaders(headers),
        });
        return result.data;
    }
}

export { GenericApiAdapter as default };
//# sourceMappingURL=genericApiAdapter.js.map
